import React, { useRef } from "react";
import { CTAButton } from "./UI";
import { useScrollReveal } from "../hooks";

const CHANNELS = [
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M20.52 3.48A11.93 11.93 0 0 0 12 0C5.37 0 0 5.37 0 12c0 2.11.55 4.17 1.6 5.98L0 24l6.18-1.62A11.94 11.94 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.2-1.25-6.22-3.48-8.52zm-8.52 18.43a9.9 9.9 0 0 1-5.04-1.38l-.36-.22-3.74.98 1-3.65-.24-.38A9.9 9.9 0 0 1 2.1 12C2.1 6.53 6.53 2.1 12 2.1c2.65 0 5.14 1.03 7.01 2.9a9.87 9.87 0 0 1 2.9 7.01c-.01 5.46-4.44 9.9-9.91 9.9zm5.43-7.42c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.65-2.04-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.87 1.21 3.07.15.2 2.1 3.2 5.08 4.49.71.31 1.27.49 1.7.63.72.23 1.37.2 1.88.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.12-.27-.2-.57-.34z" fill="currentColor"/>
      </svg>
    ),
    title: "Meta Ads",
    body: "Facebook & Instagram advertising that targets your ideal customer and drives real results.",
    tag: "Paid Social",
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M11 8v6M8 11h6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
      </svg>
    ),
    title: "Google Ads",
    body: "Show up when people are searching for exactly what you offer. Pay-per-click that actually pays off.",
    tag: "Paid Search",
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M12 3C12 3 8 7 8 12s4 9 4 9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
        <path d="M12 3c0 0 4 4 4 9s-4 9-4 9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
        <path d="M3 12h18" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
        <path d="M4.5 7.5h15M4.5 16.5h15" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
      </svg>
    ),
    title: "SEO",
    body: "Rank higher on Google organically. Long-term visibility that compounds over time.",
    tag: "Organic",
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3.5" y="3.5" width="17" height="17" rx="5" stroke="currentColor" strokeWidth="1.5"/>
        <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.4"/>
        <circle cx="17.2" cy="6.8" r="1.1" fill="currentColor"/>
      </svg>
    ),
    title: "Social Media",
    body: "Consistent presence, community building and content strategy across the right platforms.",
    tag: "Organic",
  },
];

export default function Performance() {
  const ref = useRef(null);
  const visible = useScrollReveal(ref);

  return (
    <section id="performance" className={"section section-border reveal-section" + (visible ? " revealed" : "")} ref={ref}>
      <div className="container">

        <div className="perf-head reveal-child" style={{ transitionDelay: "0s" }}>
          <div className="perf-head-left">
            <span className="eyebrow">Growth · Ads · SEO</span>
            <h2 className="h2" style={{ marginTop: 16 }}>
              Get in front of the right people. At the right time.
            </h2>
          </div>
          <p className="lede perf-head-right">
            We run paid and organic marketing that connects your brand with people who are ready to buy — and builds an audience that keeps coming back.
          </p>
        </div>

        <div className="perf-channels">
          {CHANNELS.map((c, i) => (
            <div className="perf-channel reveal-child" key={c.title} style={{ transitionDelay: `${0.1 + i * 0.1}s` }}>
              <div className="perf-channel-top">
                <span className="perf-channel-icon">{c.icon}</span>
                <h3 className="perf-channel-title">{c.title}</h3>
                <span className="perf-channel-tag">{c.tag}</span>
              </div>
              <p className="perf-channel-body">{c.body}</p>
            </div>
          ))}
        </div>

        <div className="perf-bottom reveal-child" style={{ transitionDelay: "0.5s" }}>
          <p className="perf-statement">
            Creative gets attention. Strategy turns it into growth.
          </p>
          <CTAButton href="#contact">Grow your business</CTAButton>
        </div>

      </div>
    </section>
  );
}
